<template>
  <div>
    <maritimeService
      :name="heading"
      subProps="Marine industry software designed to streamline operations and improve efficiency"
    />
    <v-container>
      <v-row>
        <v-col sm="12" md="7" lg="7" class="mt-sm-20 pt-5">
          <v-img
            src="@/assets/partners-2.png"
            alt="Image Description"
            class="image-overlay"
          >
            <!-- <div class="overlay">
                <span class="text-over-image"
                  >Reach out and partner with Maritime Trainer</span
                >
                <br />
                <p class="ptext">Assess, Train and Retain with us!</p>
              </div> -->
          </v-img>
        </v-col>

        <v-col sm="12" md="5" lg="5">
          <base-QuickContact />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center pt-5">
          <h1>Partnership Categories</h1>
          <br />
          <p>
            If you want to become a partner with us, you can reach us by looking
            at our partnership categories.
          </p>
        </v-col>
      </v-row>
      <v-row class="pt-5">
        <v-col cols="12" md="6" lg="4" sm="12">
          <v-hover v-slot="{ hover }" open-delay="100">
            <v-card
              class="card"
              variant="outlined"
              :elevation="hover ? 16 : 2"
              :class="{ 'on-hover': hover }"
            >
              <div class="text-center pt-5">
                <v-icon class="centered-icon" color="blue" size="90px">
                  mdi mdi-account-check-outline
                </v-icon>
              </div>
              <h4 class="text-center pt-4 pb-4">SME (Subject Matter Expert)</h4>
              <p class="text-center pl-3 pb-3 pr-3 pt-3">
                If you possess expertise in developing courses for the maritime
                and offshore industries, I'd love to collaborate and become
                partners.
              </p>
            </v-card>
          </v-hover>
        </v-col>

        <!-- <v-col cols="12" md="6" lg="4" sm="12">
          <v-hover v-slot="{ hover }" open-delay="100">
            <v-card
              class="card"
              :elevation="hover ? 16 : 2"
              :class="{ 'on-hover': hover }"
            >
              <div class="text-center pt-5">
                <v-icon class="centered-icon" color="blue" size="90px">
                  mdi mdi-pencil-outline
                </v-icon>
              </div>
              <h4 class="text-center pt-4 pb-4">eLearning Course Designer</h4>
              <p class="text-center pl-3 pb-3 pr-3 pt-3">
                Let's feature your maritime industry-related courses on our
                marketplace for both corporate and individual direct sales.
              </p>
            </v-card></v-hover
          ></v-col
        > -->
        <v-col cols="12" md="6" lg="4" sm="12">
          <v-hover v-slot="{ hover }" open-delay="100">
            <v-card
              class="card"
              :elevation="hover ? 16 : 2"
              :class="{ 'on-hover': hover }"
            >
              <div class="text-center pt-5">
                <v-icon class="centered-icon" color="blue" size="90px">
                  mdi mdi-cash
                </v-icon>
              </div>
              <h4 class="text-center pt-4 pb-4">Reseller</h4>

              <p class="text-center pl-3 pb-3 pr-3 pt-3">
                We'd like to enhance our business presence in your local market
                and offer marketing and technical support through our team.
              </p></v-card
            ></v-hover
          ></v-col
        >

        <!-- <v-col cols="12" md="6" lg="4" sm="12">
          <v-hover v-slot="{ hover }" open-delay="100">
            <v-card
              class="card"
              :elevation="hover ? 16 : 2"
              :class="{ 'on-hover': hover }"
            >
              <div class="text-center pt-5">
                <v-icon class="centered-icon" color="blue" size="90px">
                  mdi mdi-lightbulb-variant-outline
                </v-icon>
              </div>
              <h4 class="text-center pt-4 pb-4">Strategic</h4>
              <p class="text-center pl-3 pb-3 pr-3 pt-3">
                Form a strategic partnership if your business can benefit from
                the integration of innovative technology solutions that
                complement your operations. Embrace digital transformation to
                foster growth and advancement.
              </p></v-card
            ></v-hover
          ></v-col
        > -->

        <v-col cols="12" md="6" lg="4" sm="12">
          <v-hover v-slot="{ hover }" open-delay="100">
            <v-card
              class="card"
              :elevation="hover ? 16 : 2"
              :class="{ 'on-hover': hover }"
            >
              <div class="text-center pt-5">
                <v-icon class="centered-icon" color="blue" size="90px">
                  mdi mdi-monitor-speaker
                </v-icon>
              </div>
              <h4 class="text-center pt-4 pb-4">Technology</h4>
              <p class="text-center pl-3 pb-3 pr-3 pt-3">
                Join us as a partner and revolutionize maritime operations with
                cutting-edge software solutions. Unlock new revenue streams with
                our innovative technology. Together, let's lead the future of
                the maritime industry!
              </p></v-card
            ></v-hover
          ></v-col
        >
      </v-row>
    </v-container>
  </div>
</template>

<script>
import maritimeService from "../../components/maritime-service.vue";
export default {
  components: {
    maritimeService
  },

  data: () => ({ heading: "" }),
  mounted() {
    this.heading = "partner";
  }
};
</script>

<style scoped>
.mt-sm-20 {
  text-align: justify;
}
h2 {
  font-size: 30px;
  color: rgb(3, 50, 97);
}

.image-overlay {
  position: relative;
}

.overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: left;
  color: white;
  padding: 10px;
}

.text-over-image {
  font-size: 52px;
  font-weight: bold;
  text-align: justify;
  padding: 10px;
}

.ptext {
  font-size: 15px;
  font-weight: bold;
}

@media (max-width: 960px) {
  .mt-sm-20 {
    margin-top: 150px;
    padding: 25px;
  }
}

@media (max-width: 800px) {
  .mt-sm-20 {
    margin-top: 140px;
    padding: 25px;
  }
}

@media (max-width: 600px) {
  .mt-sm-20 {
    margin-top: 155px;
    padding: 25px;
  }
}

@media (max-width: 500px) {
  .mt-sm-20 {
    margin-top: 200px;
    padding: 25px;
  }
}
@media (max-width: 400px) {
  .mt-sm-20 {
    margin-top: 220px;
    padding: 25px;
  }
}
</style>
